module.exports = __webpack_public_path__ + "static/media/400156_01.6c9b5b18.png";